import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ComputeCreditMeter from './ComputeCreditMeter.jsx';
import { useAuth } from '../context/AuthContext.jsx';
import { useComputeCredit } from '../context/ComputeCreditContext.jsx';

export default function TopBar({ onMenuClick, theme, onToggleTheme }) {
  const { user, logout } = useAuth();
  const { wallet } = useComputeCredit();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const tierLabel = wallet?.tier ? wallet.tier.toUpperCase() : (user ? 'PAYG' : 'Guest seat');

  async function handleLogout() {
    setMenuOpen(false);
    await logout();
    navigate('/', { replace: true });
  }

  return (
    <header className="aq-topbar">
      <button className="aq-topbar-menu" onClick={onMenuClick} aria-label="Toggle navigation">
        ☰
      </button>

      <div className="aq-topbar-spacer" />

      <ComputeCreditMeter />

      <button className="aq-theme-toggle" onClick={onToggleTheme} aria-label="Toggle theme">
        {theme === 'dark' ? '☀️' : '🌙'}
      </button>

      <div className="aq-profile-menu">
        <button
          className="aq-profile"
          onClick={() => setMenuOpen((v) => !v)}
          aria-haspopup="true"
          aria-expanded={menuOpen}
        >
          <div className="aq-profile-avatar">{(user?.email || 'AQ').slice(0, 2).toUpperCase()}</div>
          <div className="aq-profile-meta">
            <span className="aq-profile-name">{user?.email || 'Guest seat'}</span>
            <span className="aq-profile-role">{tierLabel} seat</span>
          </div>
        </button>

        {menuOpen && (
          <>
            <div className="aq-profile-menu-backdrop" onClick={() => setMenuOpen(false)} />
            <div className="aq-profile-dropdown" role="menu">
              <div className="aq-profile-dropdown-email">{user?.email}</div>
              <button className="aq-profile-dropdown-item" onClick={() => { setMenuOpen(false); navigate('/app/billing'); }} role="menuitem">
                Billing & credits
              </button>
              <button className="aq-profile-dropdown-item" onClick={handleLogout} role="menuitem">
                Log out
              </button>
            </div>
          </>
        )}
      </div>
    </header>
  );
}
